import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const ProductTagsQuery = gql`
    query ($domain: String!) {
        productTags(where: { eshop: { domain: $domain }}) {
            id
            name
            slug
            title
            color
            active
        }
        languages {
            id
            value
        }
    }
`;

const CreateProductTag = gql`
    mutation($productTag: CreateProductTagInput!) {
        createProductTag(productTag: $productTag) {
            id
        }
    }
`;

const UpdateProductTag = gql`
    mutation($id: String!, $productTag: UpdateProductTagInput!) {
        updateProductTag(id: $id, productTag: $productTag) {
            id
        }
    }
`;

const DeleteProductTag = gql`
    mutation($id: String!) {
        deleteProductTag(id: $id) {
            id
        }
    }
`;

interface IInputProps {
    children?: any;
}

interface Response {
    data: any;
}

class GetProductTagsQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
    render() {
        const {
            productTags,
            createProductTag,
            updateProductTag,
            deleteProductTag
        }: any = this.props;
        return this.props.children({
            productTags,
            createProductTag,
            updateProductTag,
            deleteProductTag
        });
    }
}

export default compose(
    graphql<IInputProps, Response>(ProductTagsQuery, {
        name: 'productTags'
    }),
    graphql<IInputProps, Response>(CreateProductTag, {
        name: 'createProductTag'
    }),
    graphql<IInputProps, Response>(UpdateProductTag, {
        name: 'updateProductTag'
    }),
    graphql<IInputProps, Response>(DeleteProductTag, {
        name: 'deleteProductTag'
    })
)(GetProductTagsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/ProductTags/ProductTags.tsx